export default "__VITE_ASSET__C85xv$A8__"